<template >
  <div v-if="renderComponent">
    
   
    <div class="table-responsive mt-2" ref="formContainer">
      <div class="card card-body px-0" style="border-radius: 10px">
        <div class="row" style="margin-bottom: 1px;margin-left: 0px; justify-content:space-between;">
          <div class="col-3 px-2">
            <div class="form-group">
              <label style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px">Select Organization</label>
              <multiselect :options="organizations" :allow-empty="true" :searchable="true" :multiple="true"
                :selectedLabel="null" :deselectLabel="null"  :selectLabel="null"
                @input="organizationSearch(org_search)" v-model="org_search" label="name"
                track-by="organization_id">
              </multiselect>
            </div>
          </div>
          <div class="col-3 px-2" v-if="!$route.fullPath.includes('/users/master')">
            <label style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px">Organization Status</label>

             <multiselect v-if="this.product == 1" @input="orgStatus($event)" :options="selected_org_status"  placeholder='All' :multiple="true"
                :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" 
                v-model="org_status" label="name" track-by="value" style="font-size:12px !important">

              </multiselect>
            </div>
          <div class="col-3 px-2" v-if="!$route.fullPath.includes('/users/master')">
            <label style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px">Type</label>

             <multiselect v-if="this.product == 1" @input="changeType($event)" :options="selected_types"  placeholder='All' :multiple="true"
                :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" 
                v-model="selectedType" label="name" track-by="value" style="font-size:12px !important">

              </multiselect>

            <!-- <select v-if="this.product == 0" v-on:change="changeType($event)" class="demo-date form-control users_type_list" v-model="selectedType">
              <option value="">All</option>
              <option value="0">Admin</option>
              <option value="10">Customers</option>
              <option value="6">Drivers</option>
              <option value="3">Manager</option>
              <option value="9">Production Supervisor</option>
              <option value="4">Shipping &amp; Receiving</option>
            </select> -->

            <multiselect v-if="this.product == 1" :options="staffer_users_type" :allow-empty="false" :searchable="true" 
                :selectedLabel="null" :deselectLabel="null"  :selectLabel="null"
                @input="changeType($event)" v-model="selectedType" label="name"
                track-by="id">
              </multiselect>
            <!-- <select v-if="this.product == 1" v-on:change="changeType($event)" class="demo-date form-control users_type_list" v-model="selectedType">
              <option value="">All</option>
              <option v-for="staffer_users_types in staffer_users_type" :key="staffer_users_types.id" 
                :value="staffer_users_types.name">{{staffer_users_types.name}}
              </option>

            </select> -->
            
          </div>
          <div class="col-3 px-2 search-div float-right">
            <div class="col-10 px-2" :style="{width: ($route.fullPath.includes('/users/master')? '35%': '25%')}">
              <!-- Search -->
              <div class="" ref="formContainer">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px" for="">Search</label>
                <div class="has-search">
                  <span class="fa fa-search form-control-feedback"></span>
                  <input type="text" v-model="search" @keyup="usersBySearch"
                    class="form-control" placeholder="Search Here..." />
                </div>
              </div>
            </div>
            <div v-if="$route.fullPath.includes('/users/master')" class="col-2 form-group text-right pr-3" style="float: right;margin-top: 2rem !important;">
              <button @click="create_user()" type="button" class="btn btn-sm float-right btn-outline-light add-lead" style="
                color: white;
                cursor: pointer;
                border: 1px solid #48a6a6;
                padding: 8px 10px 4px 10px;
              ">
                <span class="fa fa-plus" style="font-size:20px;color:#48a6a6;"></span>
              </button>
              <!-- <span v-if="$route.fullPath.includes('/users/master')" @click="create_user()" style="font-size:20px"  class="fa fa-plus btn-basic"></span> -->
            </div>
            <div v-if="!$route.fullPath.includes('/users/master')" class="col-2 form-group text-right pr-3" style="float: right;margin-top: 2rem !important;">
            <!-- <span v-if="$route.fullPath.includes('/users/master')" @click="create_user()" style="font-size:20px"  class="fa fa-plus btn-basic"></span> -->

              <!-- <a v-if="$route.fullPath.includes('/users/master')" @click="create_user()" class="btn-basic">Add New</a> -->
              <download-excel class="btn btn-sm btn-outline-light excel-download"  style="
                  color: #48a6a6 !important;
                  border: 1px solid #48a6a6;
                  padding: 7px 10px 4px 10px;
                  margin-right: 6px;
                  cursor: pointer;
                " :name="excelFileName" :data="excelDownloadData" :fields="json_fields"><i class="fa fa-file-excel-o" style="font-size:21px"></i>
              </download-excel>
            </div>
          </div>
        </div>

        <table class="table table-hover" id="dataTable" width="100%" cellspacing="0">
          <thead>
            <tr class="" style="color: #48a6a6; background-color: #f4f8fa">
              <th>Organization Name</th>
              <th>Name</th>
              <!-- <th>Avatar</th> -->
              <th>Username</th>
              <th>Email</th>
              <th>Role</th>
              <th>Subscribed</th>
              <th class="pl-5">Action</th>
            </tr>
          </thead>
          <tbody>
             <tr  v-if="isLoader" id="user_skeleton_loader" >
                <td colspan="16">
                  <b-skeleton-wrapper >
                      <b-skeleton height="40px" ></b-skeleton>   
                      <b-skeleton height="40px"></b-skeleton>  
                      <b-skeleton height="40px"></b-skeleton>     
                                                  
                  </b-skeleton-wrapper> 
                </td>
              </tr>
            <user-row v-show="!isLoader"  v-for="user in filteredList" :product="product" :user="user" :key="user.id || user.master_user_id" :isLoader="showskLoader" @loaderStatus="setLoaderStatus"></user-row>
          </tbody>
        </table>

        <h5 style="text-align: center" v-if="filteredList.length < 1 && !isLoader">
          No data found.
        </h5>

        <paginate v-if="!isLoader" v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''"
          :next-text="''" :first-button-text="''" :last-button-text="''" :first-last-button="true"
          :container-class="'pagination pagination-sm ml-auto'" :page-class="'page-item'" :prev-class="'page-item prev'"
          :next-class="'page-item next'" :page-link-class="'page-link'" :prev-link-class="'page-link'"
          :next-link-class="'page-link'"></paginate>
      </div>
      <!-- <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>Select Organization</label>
        <multiselect
        :options="organizations"
        :allow-empty="false"
        :searchable="true"
        @input="organizationSearch($event)"
        v-model="organization_search"
        label="name"
        track-by="organization_id"
        >
      </multiselect>
      </div>
    </div>

  <div class="col-md-4">
    <label>Type</label>
    <select v-on:change="changeType($event)" class="demo-date" v-model="selectedType">
        <option value="">All</option>
        <option value="0">Admin</option>
        <option value="10">Customers</option>
        <option value="6">Drivers</option>
        <option value="3">Manager</option>
        <option value="9">Production Supervisor</option>
        <option value="4">Shipping &amp; Receiving</option>
    </select>
  </div>
    </div> -->
      <!-- <div class="col-md-8">
      <input type="checkbox" @click="subscribeUsers()" id="subscribed-users" />
      <span class="checkmark"></span>
      Get all users subscribed to Email notification
    </div> -->
      &nbsp;&nbsp;&nbsp;

      <!-- -->
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import Multiselect from "vue-multiselect";
  import UserRow from "./user_row";
  import UserForm from "./user_form";

  export default {
    components: {
      UserRow,
      Multiselect,
    },

    data: function () {
      return {
        search: "",
        selectedType: "",
        renderComponent: true,
       // organization_search: "",
        org_search: '',
        org_search_value: "all",
        organizations: [],
        staffer_users_type: [],
        selected_value: '',
        selected_types: [
                {name:"Admin", value:"0"},
                {name:"Customers", value:"10"},
                {name:"Drivers", value:"6"},
                {name:"Manager", value:"3"},
                {name:"Production Supervisor", value:"9"},
                {name:"Shipping &amp; Receiving", value:"4"}
            ],
        org_status:'',
        selected_org_status: [
            {name:"Active", value:"1"},
            {name:"Trial", value:"2"},
            {name:"Inactive", value:"3"},
            {name:"Warning", value:"4"},
            ],    
        awaitingSearch: false,
        product: localStorage.getItem('product'),
        isLoader: true,
        excelFileName: "users.xls",
        json_fields: {
          "organization name": "organization_name",
          Name: "first_name",
          "User name": "user_name",
          Email: "email",
          Role: {
            field: "role_id",
            
            callback: (value) => {
              if(this.product == 1){
                  return value;
              }
              else{
                if (value == 10) {
                  return `Customer`;
                } else if (value == 6) {
                  return `Driver`;
                } else if (value == 3) {
                  return `Manager`;
                } else if (value == 9) {
                  return `Production Supervisor`;
                } else if (value == 4) {
                  return `Shipping and Receiving`;
                } else if (value == 0) {
                  return `Admin`;
                }
              }
            },
          },
          Status: {
            field: "send_update_email",
            callback: (value) => {
              if (value == 1) {
                return `Subscribed`;
              } else {
                return `Not Subscribed`;
              }
            },
          },
         
        },
        excelDownloadData:[],
      };
    },

    props: ["users", "totalPages", "page", "organization_search","setskeletonLoader"],
    mounted: function(){
      this.org_search = this.organization_search;
      this.selectedType= this.status;
      this.org_status = this.type;
      this.org_search = this.set_selected_org;
      console.log("mounted",this.status,this.type);
    },
    computed: {
      selectedProduct: function () {
        return this.$store.getters["persist/selectedProduct"];
      },
      currentPage: {
        get: function () {
          return this.$store.getters["users/userCurrentPage"];
        },
        set: function () { },
      },
      status: function() {
        this.org_status = this.$store.getters['users/status'];
        return this.org_status;
      },
      type: function() {
        this.selectedType = this.$store.getters['users/type'];
        return this.selectedType;
      },
      search_data: function() {
        this.search = this.$store.getters['users/search'];
        return this.search;
      },
      set_selected_org:function() {
        this.org_search = this.$store.getters['users/setSelectedOrg'];
        return this.org_search;
      },
      filteredList() {
        return this.users;
        // return this.users.filter(user => {
        //   return user.user_name.toLowerCase().includes(this.search.toLowerCase()) || user.first_name.toLowerCase().includes(this.search.toLowerCase())
        // })
        // // return person.name.toLowerCase().indexOf(self.search.toLowerCase()) >= 0
        // || person.eyes.toLowerCase().indexOf(self.search.toLowerCase()) >= 0;
      },
      showskLoader:function(){
        this.isLoader = this.setskeletonLoader;
        return this.setskeletonLoader;
      }
      
    },
    ////////////
    watch: {
      selectedProduct: function () {
        
        this.product = localStorage.getItem('product');
        this.selected_value = "";
      
        // alert(this.product);
        axios.get("/admin/users/get-all-organizations?product=" + this.product).then((response) => {
        // alert("hello");
        this.organizations = response.data;
        this.organizations.unshift({
          name: "All Organizations",
          organization_id: "all",
        });
        // loader.hide();
      });


      if(this.product == 1){
        axios.get("/admin/users/get_all_org_users_type?product=" + this.product).then((response) => {
          this.staffer_users_type = response.data;
           this.staffer_users_type.unshift({
          name: "All",
          id: ""
          
        });
          // loader.hide();
        });
      }
      



      // this.getExcelOrgUsers(this.product);
      },
   
      showskLoader: function () {
        this.isLoader = this.setskeletonLoader;
        return this.setskeletonLoader;
      }
     } ,
    async created() {
      this.product = localStorage.getItem('product');
      console.log("this.setskeletonLoader(true);",this.setskeletonLoader)
      this.isLoader = this.setskeletonLoader;
      this.org_search = this.organization_search;
      // let loader = this.$loading.show({
      //       loader: 'dots',
      //       container: this.fullPage ? null : this.$refs.formContainer,
      //   });
      await axios.get("/admin/users/get-all-organizations?product=" + this.product).then((response) => {
        // alert("hello");
        this.organizations = response.data;
        // this.organizations.unshift({
        //   name: "All Organizations",
        //   organization_id: "all",
        // });
        // loader.hide();
        setTimeout(() => {
          this.isLoader= false;
        }, 400);
        
      });
      if(this.product == 1){
        axios.get("/admin/users/get_all_org_users_type?product=" + this.product).then((response) => {
          this.staffer_users_type = response.data;
          // loader.hide();
           this.staffer_users_type.unshift({
            name: "All",
            id: ""
            
          });
        });
      }

      this.getExcelOrgUsers(this.product);
      // setTimeout(() => loader.hide(), 1 * 5000)
    },
    methods: {
      
      getExcelOrgUsers(product) {
        let org_ids  = (this.org_search!='' && this.org_search!=undefined)?this.org_search.map(({ organization_id }) => organization_id): '';
        let role_id = (this.selectedType!='')?this.selectedType.map(({ value }) => value):null;
        let org_status  = (this.org_status!='')? this.org_status.map(({ value }) => value):null;
        // let org_type  = (this.org_status!='')?this.org_status.map(({ value }) => value):null;
        // this.selected_value = (this.selectedType!='')?this.selectedType.map(({ value }) => value):null;
        axios
          .get("/admin/users?limit=" + 0 + '&status=' + org_status +'&role_id=' + role_id +'&search=' + this.search   + '&organization=' + org_ids +"&product=" + this.product )
          .then((response) => {
            let res = response.data;
            this.excelDownloadData = res.data;
          });
      },
      setPage(page) {
        this.$emit("setPage", page, this.org_search_value);
      },

      clear() {
        this.results = "";
        this.search = "";
      },

      handleSearch: _.debounce(function () {
        this.preApiCall();
      }, 500),

      preApiCall() {
        if (cancel != undefined) {
          cancel();
        }
        this.apiCall(this.search);
      },

      apiCall(query) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.isLoader = true;
        let self = this;
        let subsribed_user = "";
        this.$store
          .dispatch("users/getAllUsers", [self.page, self.search, subsribed_user])
          .then(function () {
            this.isLoader = false;
          });
      },
      subscribeUsers() {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.isLoader = true;

        let self = this;
        var subsribed_user = $("#subscribed-users").prop("checked");
        setTimeout(() => {
        if (subsribed_user == true) {
          this.$store
            .dispatch("users/getAllUsers", [
              self.page,
              self.search,
              subsribed_user,
            ])
            .then(() => {
              this.isLoader = false;
            });
        } else {
          this.organizationSearch();
          this.isLoader = false;
        }
      },600);
        // setTimeout(() => loader.hide(), 1 * 1000)
      },
      organizationSearch(event) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.isLoader = true;
        this.search="";
        let self = this;
        // this.org_search_value =
        //   this.org_search != undefined
        //     ? this.org_search.organization_id
        //     : "";

        let org_id  = (this.org_search != undefined) ? this.org_search.map(({ organization_id }) => organization_id): '';
        console.log("org id",org_id);
        let users_method = (this.$route.fullPath == "/users/master") ? "get_master_users_list": "getusersByType";
        let user_params = (users_method == "get_master_users_list") ? [1,org_id]: [1 , this.org_status ,this.selectedType ,this.search, this.org_search];
        setTimeout(() => {
          this.$store
            .dispatch("users/" + users_method,user_params)
            .then(() => {
              this.getExcelOrgUsers(this.product);
              this.isLoader = false;
              this.$forceUpdate();
            });
          },600);
        // this.$emit("setPage", 1, this.org_search_value);
        // if (this.org_search_value == "all") {
        //   this.selectedType = "";
        // }
      },
      usersBySearch() {
    
      let roleId = 0;
        // let roleId,org_type,select_type,org_id = "";
        // org_id  = (this.org_search != undefined) ? this.org_status.map(({ organization_id }) => organization_id): '';
        if(this.$route.fullPath == "/users/master"){
          roleId = 1;
        }else{
          // org_type  = (this.org_status!='')?this.org_status.map(({ value }) => value):null;
          // select_type = (this.selectedType!='')?this.selectedType.map(({ value }) => value):null;
          // roleId = select_type || null;
        }
        if (!this.awaitingSearch) {
          setTimeout(() => {
            // let loader = this.$loading.show({
            //   loader: "dots",
            //   container: this.fullPage ? null : this.$refs.formContainer,
            // });
            this.isLoader = true;
            this.$store.dispatch("users/getusersByType", [1,this.org_status,this.selectedType,this.search,this.org_search])
              .then(() => {
                this.getExcelOrgUsers(this.product);
                this.isLoader = false;
                this.$forceUpdate();
              });
            this.awaitingSearch = false;
          }, 600);
        }
        this.awaitingSearch = true;
      },
      changeType(event) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        console.log("type", this.selectedType);
        // let org_type  = (this.org_status!='')?this.org_status.map(({ value }) => value):null;
        this.isLoader = true;
        this.search="";
        if(this.product == 1){
          if(event.name == "All"){
            var type = "";
          }
          else{
            var type = event.name;
          }
           this.selected_value = this.selectedType.name;          
        }
        else{
          var type = event.value;
          this.selected_value = this.selectedType.value;
        }

        // let org_id  = (this.org_search != undefined) ? this.org_status.map(({ organization_id }) => organization_id): '';
        // type = (this.selectedType!='')?this.selectedType.map(({ value }) => value):null;
        setTimeout(() => {
        this.$store
          .dispatch("users/getusersByType", [1, this.org_status, this.selectedType, this.search,this.org_search])
          .then(() => {
            this.isLoader = false;
          });
        this.getExcelOrgUsers(this.product);
        },800);
        // setTimeout(() => this.isLoader = false, 1 * 500);
      },
      orgStatus(){
        
        // let org_type  = (this.org_status!='')?this.org_status.map(({ value }) => value):null;
        // let select_type = (this.selectedType!='')?this.selectedType.map(({ value }) => value):null;
        // let org_id  = (this.org_search != undefined) ? this.org_status.map(({ organization_id }) => organization_id): '';
        // console.log("org_type",this.org_status,org_type);
        this.isLoader = true;
        this.$store.dispatch('users/getusersByType', [1 , this.org_status ,this.selectedType ,this.search, this.org_search])
        .then( () => {
           setTimeout(() => {
          // loader.hide();
          this.getExcelOrgUsers(this.product);
            this.isLoader = false;
            this.setskeletonLoader(false);
          }, 1000);
           
          });
      },
      create_user(user_id = null) {
        this.$store.dispatch("modal/update", {
          action: "create",
          title: user_id == undefined ? "Add User" : "Update User",
          formData: user_id,
          component: UserForm,
        });
      },
      setLoaderStatus(val){
        console.log("set loader",val);
          this.isLoader = val;
          this.$forceUpdate();
      },
    },
  };
</script>

<style>
  .table tbody tr:hover td,
  .table-hover tbody tr:hover th {
    background-color: #f4f8fa;
  }

  .table {
    /* font-size: 0.9rem; */
    font-size: 14px;
    font-weight: 400;
    /* position: relative; */
  }

  .table td {
    vertical-align: middle;
  }

</style>

<style scoped lang="scss">
select.demo-date.form-control.users_type_list {
    background: url("data:image/svg+xml,<svg height='10px' width='10px' viewBox='0 0 16 16' fill='rgb(50%,50%,50%)' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>") no-repeat;
    background-position: calc(100% - 0.75rem) center !important;
    -moz-appearance:none !important;
    -webkit-appearance: none !important; 
    appearance: none !important;
    padding-right: 2rem !important;
    height: 43px;
    border-radius: 0px;

}
.table-responsive{
  overflow-x: hidden !important;
}
 table tr th:nth-child(1) {
    width: 17% !important;
  }
   table tr th:nth-child(2) {
    width: 13% !important;
  }
   table tr th:nth-child(3) {
    width: 13% !important;
  }
   table tr th:nth-child(4) {
    width: 17% !important;
  }
   table tr th:nth-child(5) {
    width: 13% !important;
  }
   table tr th:nth-child(6) {
    width: 10% !important;
  }
  table tr th:nth-child(7) {
    width: 27% !important;
  }
  .has-search .form-control {
    height: calc(1.3em + 0.75rem + 6px) !important;
  }
  .btn-basic{
    padding: 0.7rem 1rem 0.3rem 1rem  !important;
  }
  .excel-download:hover,.btn:hover{
    background: #48a6a6;
    .fa-file-excel-o,  .fa-plus{
      color: white !important;
    } 
  }
  .search-div{
    padding:0px; 
    display:flex;
  }
  @media only screen and (min-width: 1280px) and (max-width: 1724px) {
    tr {
      font-size: 12px;
    }
  }
</style>